import { MetricName } from "components/Transactional/Performance/components/MetricsSelect/interfaces"
import {
	TRANSACTIONAL_BENCHMARK,
	TRANSACTIONAL_BENCHMARK_BY_BRANDS,
	TRANSACTIONAL_BENCHMARK_BY_CHANNELS,
	TRANSACTIONAL_BENCHMARK_BY_FORMATS,
	TRANSACTIONAL_BENCHMARK_BY_LOCATION,
	TRANSACTIONAL_BENCHMARK_BY_TOTAL_SALES,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_BRAND,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_CHANNEL,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_FORMAT,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LEVEL,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LOCATION,
} from "constants/paths"

export const disabledMetric: Record<MetricName, boolean> = {
	sales: false,
	units: false,
	transactions: false,
	clients: false,
	penetration: false,
	"purchase-frequency": false,
	"items-per-visit": false,
	"average-price-per-item": false,
	"average-spend": false,
	"average-ticket": false,
	"stores-selling": false,
}

export const enabledModules: Array<string> = [
	TRANSACTIONAL_BENCHMARK,
	TRANSACTIONAL_BENCHMARK_BY_TOTAL_SALES,
	TRANSACTIONAL_BENCHMARK_BY_CHANNELS,
	TRANSACTIONAL_BENCHMARK_BY_FORMATS,
	TRANSACTIONAL_BENCHMARK_BY_LOCATION,
	TRANSACTIONAL_BENCHMARK_BY_BRANDS,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_BRAND,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_CHANNEL,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_FORMAT,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LEVEL,
	TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LOCATION,
]
